"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Paper as Paper$1 } from "@mantine/core";
import { forwardRef } from "react";
import ArrowHead, { P as PaperStyles } from "./ArrowHead.js";
const _Paper = forwardRef((props, ref) => {
  const {
    children,
    target,
    variant = "primary",
    className,
    p = "md",
    mod,
    arrowPosition,
    ...rest
  } = props;
  return /* @__PURE__ */ jsxs(
    Paper$1,
    {
      ...rest,
      ref,
      p,
      shadow: "md",
      radius: "md",
      classNames: PaperStyles,
      className,
      mod: { variant, ...mod },
      children: [
        target && /* @__PURE__ */ jsx(ArrowHead, { target, variant, arrowPosition }),
        children
      ]
    }
  );
});
_Paper.displayName = "Paper";
const Paper = sharedHandler(_Paper);
Paper.displayName = _Paper.displayName;
export {
  Paper as default
};
